import { render, staticRenderFns } from "./carditem.vue?vue&type=template&id=4d099524&scoped=true&"
import script from "./carditem.vue?vue&type=script&lang=js&"
export * from "./carditem.vue?vue&type=script&lang=js&"
import style0 from "./carditem.vue?vue&type=style&index=0&id=4d099524&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d099524",
  null
  
)

export default component.exports